var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-loading",class:_vm.getClass},[_c('van-loading',{attrs:{"size":"24px","type":"spinner"}},[_vm._v("加载中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }